import { Column, Container, Grid, Header, PrimaryButton, Row, useAlignments, useSizes } from 'metrix-common3';
import { FormattedMessage } from 'react-intl';

const ProfileRecap = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    const amounts = {
        estimatedAnnualGross: props.policySummary.formattedEstimatedAnnualGross,
        estimatedAnnualPremium: props.policySummary.formattedEstimatedAnnualPremium,
        estimatedMonthlyGross: props.policySummary.formattedEstimatedMonthlyGross,
    };
    const estimatedTaxes = props.policySummary.estimatedTaxes?.value || 0;

    return (
        <Container>
            <Grid>
                <Row>
                    <Column bogutter>
                        <Header
                            size={sizes.md}
                            bottom={sizes.xs}
                            text={
                                (estimatedTaxes > 0 && (
                                    <FormattedMessage
                                        id='Profile_CommonComponents_Recap.taxesIncluded'
                                        values={amounts}
                                    />
                                )) ||
                                amounts.estimatedAnnualGross
                            }
                        />
                        {!props.policy.isSinglePayment && (
                            <Header
                                size={sizes.sm}
                                bottom={sizes.xs}
                                text={<FormattedMessage id='Profile_CommonComponents_Recap.savings' values={amounts} />}
                            />
                        )}
                        {props.policySummary.status === 'bound' ||
                            (props.policySummary.status === 'issued' && (
                                <Container
                                    inline
                                    horizontalAlignment={alignments.center}
                                    top={sizes.md}
                                    bottom={sizes.xs}
                                >
                                    <PrimaryButton
                                        clickEvent={() => props.changeTabTo('documents')}
                                        text={<FormattedMessage id='Profile_CommonComponents_Recap.downloadBinder' />}
                                    />
                                </Container>
                            ))}
                    </Column>
                </Row>
            </Grid>
        </Container>
    );
};

export default ProfileRecap;
